// app/javascript/controllers/lightbox_controller.js
import { Controller } from "@hotwired/stimulus"
import { Lightbox } from "mdb-ui-kit"

export default class extends Controller {
  static targets = ["gallery"]

  open(event) {
    event.preventDefault()

    let instance = Lightbox.getInstance(this.galleryTarget)

    // MDB safety fallback
    if (!instance) {
      instance = new Lightbox(this.galleryTarget)
    }

    instance.open(0)
  }
}
